import { BaseController } from './BaseController';

export default class IframeController extends BaseController {
  id = 'IframeController';

  init() {
    this.root = this.getRoot();

    this.frames = document.querySelectorAll('iframe');

    this.frames.forEach((frame) => {
      frame.onload = this.handleIframeLoad;
    });

    window.addEventListener("message", (event) => {
      if (event.origin === "http://laisland.test" || event.origin === "https://laisland.mx") {
        if (event.data.func === "iframeResize") {
              this.frames.forEach((frame) => {
                setTimeout(() => {
                  reassessIframeHeight(frame);
                }, 150);
              }); 
          } /*else if (event.data.func === "iframeReposition") {
            this.frames.forEach((frame) => {
              if (frame.contentWindow === event.source) {
                setTimeout(() => {
                  frame.scrollIntoView({block: 'end', inline: 'center', behavior: 'smooth'});
                }, 250);
              }
            }); 
          }*/
      }
    }, false);
  }

  handleIframeLoad = (e) => {
    reassessIframeHeight(e.target);
  }
}

var reassessIframeHeight = (elem) => {
  if (elem.dataset.autoHeight) {
    elem.height = "";
    elem.height = elem.contentWindow.document.body.scrollHeight + 'px';
  }
};
